<!-- login -->

<div class="login-page">
  <p>{{labels.lblRedirection}} <a href="{{redirectUrl}}">link</a></p>
</div>
